"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 业务系统配置模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/like_and_comment_list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportReportFile: function exportReportFile(url, data) {
    return (0, _request.default)({
      module: 'CORE',
      url: url,
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};